import { GlobalSettingEnum } from 'api/model';
import Roles, {
  HRSpeedingAccessPolicy,
  includesRoles,
  isAuthorized,
} from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';
import useGlobalSettings from './useGlobalSettings';

/**
 * Returns true when the current user may see the HR-KPI "Hastighet & GPS"
 * report. The report is gated behind a global feature toggle:
 *  - SuperAdmin always sees it (for verification before flipping the flag).
 *  - The other roles in HRSpeedingAccessPolicy (HR, Efterkontroll,
 *    Kvalitet & Utbildning) see it only when the toggle is on.
 *
 * Mirrors the backend gate in KPIController.GetHRSpeedingReport.
 */
const useHasAccessToHRSpeedingReport = (): boolean => {
  const me = useMe();
  const { parsedData } = useGlobalSettings();

  if (!me?.roles) return false;

  const isSuperAdmin = includesRoles([Roles.SuperAdmin], me.roles);
  if (isSuperAdmin) return true;

  if (
    !isAuthorized(
      HRSpeedingAccessPolicy.allow,
      HRSpeedingAccessPolicy.deny,
      me.roles
    )
  ) {
    return false;
  }

  return parsedData[GlobalSettingEnum.HRSpeedingReportEnabled] === true;
};

export default useHasAccessToHRSpeedingReport;
